import styled from "styled-components"

export const Container = styled.div`
  display: block;
  max-width: 100% !important;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 20px;
  padding-bottom: 30px;

  .skills__block {
    margin-top: 50px;
    > h2 {
      margin-bottom: 20px;
    }
  }
`
